/* eslint "no-param-reassign": "warn" */
import { connect, createProvider } from 'react-redux';
var STORE_KEY = 'SDKStore';
function connectToSDKStore(mapStateToProps, mapDispatchToProps, mergeProps) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  options.storeKey = options.storeKey || STORE_KEY;
  return connect(mapStateToProps, mapDispatchToProps, mergeProps, options);
}
export { connectToSDKStore as connect };
export var Provider = createProvider(STORE_KEY);